import './App.css';
import "./assets/css/vendor.bundle.css";
import "./assets/css/style.css";
import "./assets/css/theme.css";
import Home from './components/home/Home';
import About from './components/about/About';
import AccountTypes from './components/account_types/AccountTypes';
import Contact from './components/contact/Contact';
import Faqs from './components/faqs/Faqs';
import Bonds from './components/market_data/Bonds';
import DigitalCurrencies from './components/market_data/DigitalCurrencies';
import Forex from './components/market_data/Forex';
import Shares from './components/market_data/Shares';
import PrivacyPolicy from './components/privacy_policy/PrivacyPolicy';
import Terms from './components/terms/Terms';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/account-types" element={<AccountTypes />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/bonds" element={<Bonds />} />
          <Route path="/digital-currencies" element={<DigitalCurrencies />} />
          <Route path="/forex" element={<Forex />} />
          <Route path="/shares" element={<Shares />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
